import { render } from "./Learners.vue?vue&type=template&id=bbd25470"
import script from "./Learners.vue?vue&type=script&lang=js"
export * from "./Learners.vue?vue&type=script&lang=js"

import "./Learners.vue?vue&type=style&index=0&id=bbd25470&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__